/** Web3Forms — free tier, works from static hosting. Register at https://web3forms.com */

export const FEEDBACK_TO_EMAIL = 'info@daydreamsoftware.es';
export const FEEDBACK_API_URL = 'https://api.web3forms.com/submit';

export function getFeedbackAccessKey(): string {
  return (import.meta.env.VITE_FEEDBACK_ACCESS_KEY as string | undefined)?.trim() ?? '';
}

export function isFeedbackEnabled(): boolean {
  return Boolean(getFeedbackAccessKey());
}
